import {combineReducers} from "redux";

export function error(state = null, action) {
    switch (action.type) {
        case "REPORT_LIST_ERROR":
            return action.error;

        case "REPORT_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export function loading(state = false, action) {
    switch (action.type) {
        case "REPORT_LIST_LOADING":
            return action.loading;

        case "REPORT_LIST_RESET":
            return false;

        default:
            return state;
    }
}

export function retrieved(state = null, action) {
    switch (action.type) {
        case "REPORT_LIST_SUCCESS":
            return action.retrieved;

        case "REPORT_LIST_RESET":
            return null;

        default:
            return state;
    }
}

export default combineReducers({error, loading, retrieved});
